<template>
<div class="panel">
    <a class="item" v-for="item in menu" :key="item.title"  :href="item.link">
        <span>{{item.title}}</span>
        <img src="/static/ic_arrow_right.png"/>
    </a>
</div>
</template>

<script>
    export default{
        name:'HelpCenter',
        data() {
            return {
                menu: [
                    {
                        title:this.$t("message.wallet"),
                        link:"/help/wallet"
                    },
                    {
                        title:this.$t("message.account"),
                        link:"/help/account"
                    },
                    {
                        title:this.$t("message.csaf"),
                        link:"/help/csaf"
                    },
                    {
                        title:this.$t("message.backupAndRestore"),
                        link:"/help/backupAndRestore"
                    },
                    {
                        title:this.$t("message.committee"),
                        link:"/help/committee"
                    },
                    {
                        title:this.$t("message.witness"),
                        link:"/help/witness"
                    },
                    {
                        title:this.$t("message.authorizedRegistrars"),
                        link:"/help/authorizedRegistrars"
                    },
                    {
                        title:this.$t("message.vote"),
                        link:"/help/vote"
                    },
                    {
                        title:this.$t("message.collateral"),
                        link:"/help/collateral"
                    },
                    {
                        title:this.$t("message.gateway"),
                        link:"/help/gateway"
                    },
                    // {
                    //     title:this.$t("message.extraFunctions"),
                    //     link:"/help/extraFunctions"
                    // }
                ]
            }
        },
        mounted:function(){
            document.title = this.$t("message.helpCenter")
        }
    }
</script>

<style scoped>
    .panel{
        width:100%;
        padding-left: 15px;
        box-sizing: border-box;
    }

    .item{
        padding-top: 14px;
        padding-bottom: 14px;
        border-bottom: 1px solid #f2f4f8;
        display: flex;
        flex-flow: row nowrap;
        align-content: center;
        justify-content: space-between;
    }

    img{
        float: right;
        margin-right: 11px;
        width: 16px;
        height: 16px;
    }

    a{
        box-sizing: content-box;
        margin-left: 0.25%;
        color:#282e42;
        font-size: 16px;
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/HelpCenter.vue